import React from 'react';
import { useForm } from 'react-hook-form';
import FormWrapper from '../../../../Components/Form/FormWrapper';
import InputWrapper from '../../../../Components/Form/components/InputWrapper/InputWrapper';
import InputField from '../../../../Components/Form/components/InputField';
import TextAreaField from '../../../../Components/Form/components/TextAreaField';
import SubmitButton from '../../../../Components/Button/SubmitButton';
import { FormValues } from '../../../MagicForm/Interfaces/FormValues';
import apiClient from '../../../../Services/ApiClient';
import useApiClient from '../../../Base/Hooks/useApiClient';
import useNotification from '../../../../Hooks/useNotification.hook';
import useTranslation from '../../../../Hooks/useTranslation';

interface Props {
	onSuccess: () => void;
	group: {
		id: string;
		name: string;
		description?: string;
	};
}

const PatientsGroupsRename: React.FC<Props> = ({ group, onSuccess }) => {
	const { displayError } = useApiClient();
	const { showNotificationSuccess } = useNotification();
	const { t } = useTranslation();
	const formMethods = useForm({ defaultValues: group });

	const handleSubmit = async (values: FormValues) => {
		try {
			const result = await apiClient.patch(`/group/${group.id}`, values);
			if (result) {
				showNotificationSuccess({
					content: t('component.groupMsgs.groupEdited'),
				});
			}
		} catch (e) {
			displayError(e);
		}
		onSuccess();
	};

	return (
		<FormWrapper formMethods={formMethods}>
			<InputWrapper>
				<InputField name='name' label='base.groupName' isRequired />
			</InputWrapper>
			<InputWrapper>
				<TextAreaField name='description' label='base.groupDescription' />
			</InputWrapper>
			<SubmitButton onSubmit={handleSubmit} title='base.editGroup' />
		</FormWrapper>
	);
};

export default PatientsGroupsRename;
